module.exports = __webpack_public_path__ + "static/img/hixianchang_iphone.ebd0d78a.png";